import { render, staticRenderFns } from "./DiscountActivityBoxCompontent.vue?vue&type=template&id=24b5e6d1"
import script from "./DiscountActivityBoxCompontent.vue?vue&type=script&lang=js"
export * from "./DiscountActivityBoxCompontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports